import { DataWorker } from './data.worker'
import { eventBus } from '@/libs/EventBus'

// Measure network speed by pinging SignalR server
export const networkWorker = async () => {
  const connection = DataWorker.getInstance().getConnection()
  if (!connection) return
  try {
    const t1 = Date.now()
    await connection.invoke('ping')
    const latency = Date.now() - t1
    const t2 = Date.now()
    const data = await connection.invoke('ping_large') as string
    const transferTime = Math.max(Date.now() - t2 - latency, 1)
    const mbps = (data.length * 8 / 1000000) / (transferTime / 1000)
    eventBus.emit('networkSpeed', { latency, mbps })
  } catch (e) {
    // Ignore ping errors
  }
}
